import { toTitleCase } from "../../../../Utils/stringUtls";
import React from "react";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";

const CustomerServiceWebsiteOverview = ({ data }) => {
  const {
    ic_csw_web_agent_required,
    ic_csw_website_language,
    ic_csw_website_language_other,
    users,
  } = data["3_1"];
  return (
    <div
      className="forms-instance"
      style={{ color: "#111" }}
    >
      <div i2c-grid="grid" className="review-summary-sub-heading review-summary-gap mt-16">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading
            title="Customer Service Website (C-Agent)"
            className="mt-0 font-bold"
          />
        </div>

        <ReviewAttribute
          label="Would you like i2c C-Agent Website?"
          value={
            ic_csw_web_agent_required?.length
              ? toTitleCase(ic_csw_web_agent_required)
              : "-"
          }
        />

        {ic_csw_web_agent_required === "yes" && (
          <>
            <ReviewAttribute
              label="C-Agent Website Language"
              value={
                <div>
                  {ic_csw_website_language[0]?.length &&
                  ic_csw_website_language[0] !== "other"
                    ? `${toTitleCase(ic_csw_website_language[0])}`
                    : ""}
                  {ic_csw_website_language[1]?.length &&
                  ic_csw_website_language[1] !== "other"
                    ? `, ${toTitleCase(ic_csw_website_language[1])}`
                    : ""}
                  {ic_csw_website_language[2]?.length &&
                  ic_csw_website_language[2] !== "other"
                    ? `, ${toTitleCase(ic_csw_website_language[2])}`
                    : ""}
                  {ic_csw_website_language_other?.length
                    ? `, ${toTitleCase(ic_csw_website_language_other)}`
                    : ""}
                </div>
              }
            />
            {users.length
              ? users.map((user, index) => {
                  const {
                    iac_aw_cell,
                    iac_aw_email,
                    iac_aw_name,
                    iac_aw_phone,
                    iac_aw_title,
                  } = user;
                  return (
                    <React.Fragment key={index}>
                      <div i2c-grid="12@md">
                        <div className="review-summary-section-heading">User Details</div>
                      </div>
                      <div i2c-grid="12@md" className="review-summary-section-heading">
                        User {index + 1}
                      </div>
                      <ReviewAttribute
                        label="Name"
                        value={
                          iac_aw_name?.length ? toTitleCase(iac_aw_name) : "-"
                        }
                      />
                      <ReviewAttribute
                        label="Title"
                        value={
                          iac_aw_title?.length ? toTitleCase(iac_aw_title) : "-"
                        }
                      />
                      <ReviewAttribute
                        label="Phone Number"
                        value={iac_aw_phone?.length ? iac_aw_phone : "-"}
                      />
                      <ReviewAttribute
                        label="Cell Number"
                        value={iac_aw_cell?.length ? iac_aw_cell : "-"}
                      />
                      <ReviewAttribute
                        label="Email"
                        value={iac_aw_email?.length ? iac_aw_email : "-"}
                      />
                    </React.Fragment>
                  );
                })
              : ""}
          </>
        )}
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default CustomerServiceWebsiteOverview;
